import "style"

import "polyfill"

import AppCore from 'cores/AppCore'
import Bootstrap from 'containers/Bootstrap'

AppCore.run('#app', Bootstrap)